import type { PolicyCategory } from "../_types/policies.types";

export const POLICY_SCOPE_FILTER_OPTIONS = [
  { value: "all", label: "All scopes" },
  { value: "devices", label: "Devices" },
  { value: "groups", label: "Groups" },
  { value: "users", label: "Users" },
] as const;

export const POLICY_CATEGORY_FILTER_OPTIONS = [
  { value: "all", label: "All categories" },
  { value: "security", label: "Security" },
  { value: "compliance", label: "Compliance" },
  { value: "network", label: "Network" },
  { value: "access", label: "Access" },
] as const satisfies ReadonlyArray<{ value: PolicyCategory | "all"; label: string }>;

export type PolicyScopeFilter = (typeof POLICY_SCOPE_FILTER_OPTIONS)[number]["value"];
export type PolicyCategoryFilter = (typeof POLICY_CATEGORY_FILTER_OPTIONS)[number]["value"];
